module.exports = __webpack_public_path__ + "img/status3.f953ccba.png";